import cache from './cache.js';
import getUserAgent from './getUserAgent.js';
import regex from './isSafari.json';

// https://stackoverflow.com/questions/7944460/detect-safari-browser

export default cache('isSafari', function isSafari() {
  const pattern = new RegExp(...regex);
  return pattern.test(getUserAgent());
});